<template>
  <div class="JXData-page">
    <el-tabs v-model="agriculture" @tab-click="handleClick">
      <el-tab-pane label="当期网络零售额" name="currentSales">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth('whole')">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'" @click="wholeTime == '2'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.startTime" type="month" placeholder="选择日期" class="width-z100 chooseInput"
                                size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false" @change="getWholeList(wholeTime = 2)"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" class="width-z100 chooseInput"
                                size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false" @change="getWholeList(wholeTime = 2)"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="currentSalesOptions" autoresize class="width-z100 margin-t-30" style="height: 500px"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="currentSalesTable" stripe height="440" class="border-DEDEDE margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="累计网络零售额" name="cumulativeSales">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth('whole')">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.startTime" type="month" placeholder="选择日期" class="width-z100 chooseInput"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" @change="getWholeList(wholeTime = 2)"
                                class="width-z100 chooseInput" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="currentSalesOptions" autoresize class="width-z100 margin-t-30" style="height: 500px"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="currentSalesTable" stripe height="440" class="border-DEDEDE margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="当期网络零售量" name="currentRetail">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth()">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.startTime" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" @change="getWholeList(wholeTime = 2)"
                                class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">

          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="currentSalesOptions" autoresize class="width-z100 margin-t-30" style="height: 500px"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="currentSalesTable" stripe height="440" class="border-DEDEDE margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售量（万件）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </el-card>
      </el-tab-pane>
      <el-tab-pane label="累计网络零售量" name="cumulativeRetail">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth()">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.startTime" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" @change="getWholeList(wholeTime = 2)"
                                class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="currentSalesOptions" autoresize class="width-z100 margin-t-30" style="height: 500px"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="currentSalesTable" stripe height="440" class="border-DEDEDE margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售量（万件）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>

      </el-tab-pane>
      <el-tab-pane label="当期快递量" name="currentExpressDeliveryVolume">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth('city')">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.startTime" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" @change="getWholeList(wholeTime = 2)"
                                class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="currentSalesOptions" autoresize class="width-z100 margin-t-30" style="height: 500px"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="currentSalesTable" stripe height="440" class="border-DEDEDE margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="快递业务量（万件）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
        <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">
          注：<br/>
          1.数据来源于国家邮政局、各地区邮政管理局。
        </p>
      </el-tab-pane>
      <el-tab-pane label="累计快递量" name="cumulativeExpressDeliveryVolume">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth('city')">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.startTime" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" @change="getWholeList(wholeTime = 2)"
                                class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="currentSalesOptions" autoresize class="width-z100 margin-t-30" style="height: 500px"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="currentSalesTable" stripe height="440" class="border-DEDEDE margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="快递业务量（万件）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
        <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">
          注：<br/>
          1.数据来源于国家邮政局、各地区邮政管理局。
        </p>
      </el-tab-pane>
      <el-tab-pane label="从业人数" name="peopleEngagedNum">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth()">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.startTime" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" @change="getWholeList(wholeTime = 2)"
                                class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
            <!--            <el-form-item class="text-right">-->
            <!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
            <!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
            <!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="currentSalesOptions" autoresize class="width-z100 margin-t-30" style="height: 500px"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="currentSalesTable" stripe height="440" class="border-DEDEDE margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="从业人数（人）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_pro" label="占比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </el-card>
        <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">
          注：<br/>
          1、从业人数：根据国民经济投入产出理论，综合平台销售数据和实地调研资料，根据不同交易规模的商家建立就业系数模型，测算得到商家带动的直接就业机会。<br/>
          2、从业人数占比：本地区从业人数占上级地区从业人数的比例。地区为省时，占比为本省从业人数占全国从业人数的比例。
        </p>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    name: 'JXData',
    data () {
      return {
        agriculture: 'currentSales',
        chooseType:'当期网络零售额',//当前选择查询条件
        currentSalesOptions: {}, //当期网络零售额图表

        currentSalesTable: [],//当期网络零售额表格
        currentSalesForm: { startTime: '', endTime: ''},//当期网络零售额筛选条件
        wholeTime: '1',
        cumulativeSalesOptions:{},//累计网络零售额图表
        currentRetailOptions:{},//当期网络零售量图表
        cumulativeRetailOptions:{},//累计网络零售量图表
        peopleEngagedNumOptions:{},//从业人数图表
        ExpressDeliveryVolumeOptions:{},//快递量图表
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },


        cityChoose: [{
          id: 1,
          name: '南昌市',
          children: [{id: 1, name: '青山湖区'}, {id: 2, name: '东湖区'}, {id: 3, name: '西湖区'}, {id: 4, name: '南昌县'}, {
            id: 5,
            name: '青云谱区'
          }, {id: 6, name: '新建区'}, {id: 7, name: '进贤县'}, {id: 8, name: '湾里区'}, {id: 9, name: '安义县'}]
        },
          {id: 2, name: '九江'}, {id: 3, name: '景德镇'}, {id: 4, name: '上饶'},
          {id: 5, name: '鹰潭', children: [{id: 1, name: '贵溪市'}]}, {id: 6, name: '宜春'}, {id: 7, name: '萍乡'}, {
            id: 8,
            name: '新余'
          }, {id: 9, name: '抚州'}, {id: 10, name: '吉安'}, {id: 11, name: '赣州'}],
        productTime: '1',
        productForm: {way: '1', endTime: ''}, //商品大类筛选条件
        transactionTime: '1',
        transactionTitle: '',
        transactionForm: {way: '1', resource: '1', startTime: '', endTime: '', platform: '全部'},//交易平台筛选条件
        regionDis: true,
        //表格数据

        productTwoTable: [],

      }
    },
    mounted () {

    },
    created () {
      this.$emit('public_header', true)
      this.twelveMonth()
      // this.oneMonth()
    },
    methods: {
      dateChangebirthday (val) {
        this.wholeTime = 2
        this.currentSalesForm.value1 = val
      },
      handleClick(tab, event) {
        if(tab.name == 'cumulativeSales'){
          this.chooseType = '累计网络零售额'
          this.getWholeList();
        }
        if(tab.name == 'currentSales'){
          this.chooseType = '当期网络零售额'
          this.getWholeList();
        }
        if(tab.name == 'currentRetail'){
          this.chooseType = '当期网络零售量'
          this.getWholeList();
        }
        if(tab.name == 'cumulativeRetail'){
          this.chooseType = '累计网络零售量'
          this.getWholeList();
        }
        if(tab.name == 'peopleEngagedNum'){
          this.chooseType = '从业人数'
          this.getWholeList();
        }
        if(tab.name == 'currentExpressDeliveryVolume'){
          this.chooseType = '当期快递业务量'
          this.getWholeList();
        }
        if(tab.name == 'cumulativeExpressDeliveryVolume'){
          this.chooseType = '累计快递业务量'
          this.getWholeList();
        }
      },
      //江西省整体列表
      getWholeList () {
        this.$http.get(this.header + '/qyjc/jxWhole', {
          params: {
            index_type: this.chooseType,
            sMonth: this.currentSalesForm.startTime,
            eMonth: this.currentSalesForm.endTime
          }
        }).then(res => {
          if (res.data.code == 0) {
            let wholeList = {xTime: [], yTotalMoney: [], simple: [],unit:'',legends:''}

            res.data.monthList.forEach((y, index) => {
              wholeList.xTime.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: y.absoulte_key
              }
              let xSimple = {
                value: y.absoulte_value_yoy,
                unit: '%'
              }
              wholeList.yTotalMoney.push(yMoney)
              wholeList.simple.push(xSimple)
              wholeList.unit = y.absoulte_key
              wholeList.legends = y.index_type
            })

            let Min1 = this.calMin(wholeList.yTotalMoney), Min2 = this.calMin(wholeList.simple),
              Max1 = this.calMax(wholeList.yTotalMoney), Max2 = this.calMax(wholeList.simple)
            //当期网络零售额图表
            if(this.chooseType == '从业人数'){
              let wholeList = {xTime: [], yTotalMoney: [], simple: []}
              res.data.monthList.forEach((y, index) => {
                wholeList.xTime.push(y.times)
                let yMoney = {
                  value: y.absoulte_value,
                  unit: '人'
                }
                let xSimple = {
                  value: y.absoulte_value_yoy,
                  unit: '%'
                }
                wholeList.yTotalMoney.push(yMoney)
                wholeList.simple.push(xSimple)
              })
              this.currentSalesTable = res.data.monthList.reverse()
              let Min1 = this.calMin(wholeList.yTotalMoney), Min2 = this.calMin(wholeList.simple),
                Max1 = this.calMax(wholeList.yTotalMoney), Max2 = this.calMax(wholeList.simple)
              this.currentSalesOptions = {
                title: {//图表标题
                  text: '江西省' + this.chooseType + '变化趋势',
                  left: 'left',
                  textStyle: {
                    color: '#313131',
                    fontSize: 18,
                    fontWeight: 300
                  },
                },
                toolbox: { //图表工具箱
                  feature: {
                    magicType: {show: true, type: ['line', 'bar']},
                    restore: {show: true},
                    saveAsImage: {show: true}
                  }
                },
                tooltip: { // 鼠标悬浮
                  backgroundColor: 'rgba(50,50,50,0.7)',
                  trigger: 'item',
                  formatter: function (e) {
                    return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                  }
                },
                legend: {//图表说明  horizontal竖着显示vertical横显示
                  orient: 'horizontal',
                  y: 'bottom',
                  // x: 'left',
                  textStyle: {
                    color: '#666',
                    fontSize: 14
                  },
                  data: ['从业人数', '同比']
                },
                xAxis: {
                  type: 'category',
                  data: wholeList.xTime,
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  }
                },
                yAxis: [
                  {
                    type: 'value',
                    name: '人',
                    min: Min1,
                    max: Max1,
                    splitNumber: 5,
                    interval: (Max1 - Min1) / 5,
                    axisLine: {
                      lineStyle: {
                        color: '#666'
                      }
                    },
                  }],
                series: [{
                  name: '从业人数',
                  type: 'bar',
                  barCategoryGap: '60%',
                  itemStyle: {
                    normal: {
                      color: '#7888ed',
                    },
                    emphasis: {
                      color: '#83bff6'
                    }
                  },
                  data:wholeList.yTotalMoney,
                  smooth: true
                }]
              }
            }else if(this.chooseType == '当期快递业务量' ||this.chooseType == '累计快递业务量'){
              this.currentSalesTable = res.data.monthList.reverse()
              this.currentSalesOptions = {
                color: ['#7888ed', '#FB975B'],
                title: {//图表标题
                  text: '江西省' + this.chooseType + '变化趋势',
                  left: 'left',
                  textStyle: {
                    color: '#313131',
                    fontSize: 18,
                    fontWeight: 300
                  },
                },
                toolbox: { //图表工具箱
                  feature: {
                    magicType: {show: true, type: ['line', 'bar']},
                    restore: {show: true},
                    saveAsImage: {show: true}
                  }
                },
                tooltip: { // 鼠标悬浮
                  backgroundColor: 'rgba(50,50,50,0.7)',
                  trigger: 'item',
                  formatter: function (e) {
                    return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                  }
                },
                legend: {//图表说明  horizontal竖着显示vertical横显示
                  orient: 'horizontal',
                  y: 'bottom',
                  // x: 'left',
                  textStyle: {
                    color: '#666',
                    fontSize: 14
                  },
                  data: ['快递业务量', '同比']
                },
                xAxis: {
                  type: 'category',
                  data: wholeList.xTime,
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  }
                },
                yAxis: [
                  {
                    type: 'value',
                    name: '万件',
                    min: Min1,
                    max: Max1,
                    splitNumber: 5,
                    interval: (Max1 - Min1) / 5,
                    axisLine: {
                      lineStyle: {
                        color: '#666'
                      }
                    },
                  }, {
                    type: 'value',
                    name: '%',
                    min: Min2,
                    max: Max2,
                    splitNumber: 5,
                    interval: (Max2 - Min2) / 5,
                    axisLabel: {
                      formatter: '{value}'
                    },
                    axisLine: {
                      lineStyle: {
                        color: '#666'
                      }
                    },
                  }],
                series: [{
                  name: '快递业务量',
                  type: 'bar',
                  barCategoryGap: '60%',
                  itemStyle: {

                    emphasis: {
                      color: '#83bff6',
                      // barBorderRadius: [10, 10, 10, 10]
                    }
                  },
                  data:wholeList.yTotalMoney,
                  smooth: true
                }, {
                  name: '同比',
                  type: 'line',
                  yAxisIndex: 1,

                  data: wholeList.simple
                }]
              }
            }else{
              this.currentSalesTable = res.data.monthList.reverse()
              this.currentSalesOptions = {
                title: {//图表标题
                  text: '江西省' + this.chooseType + '变化趋势',
                  left: 'left',
                  textStyle: {
                    color: '#313131',
                    fontSize: 18,
                    fontWeight: 300
                  },
                },
                toolbox: { //图表工具箱
                  feature: {
                    magicType: {show: true, type: ['line', 'bar']},
                    restore: {show: true},
                    saveAsImage: {show: true}
                  }
                },
                tooltip: { // 鼠标悬浮
                  backgroundColor: 'rgba(50,50,50,0.7)',
                  trigger: 'item',
                  formatter: function (e) {
                    return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                  }
                },
                legend: {//图表说明  horizontal竖着显示vertical横显示
                  orient: 'horizontal',
                  y: 'bottom',
                  // x: 'left',
                  textStyle: {
                    color: '#666',
                    fontSize: 14
                  },
                  data: [wholeList.legends, '同比']
                },
                xAxis: {
                  type: 'category',
                  data: wholeList.xTime,
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  }
                },
                yAxis: [
                  {
                    type: 'value',
                    name: wholeList.unit,
                    min: Min1,
                    max: Max1,
                    splitNumber: 5,
                    interval: (Max1 - Min1) / 5,
                    axisLine: {
                      lineStyle: {
                        color: '#666'
                      }
                    },
                  }, {
                    type: 'value',
                    name: '%',
                    min: Min2,
                    max: Max2,
                    splitNumber: 5,
                    interval: (Max2 - Min2) / 5,
                    axisLabel: {
                      formatter: '{value}'
                    },
                    axisLine: {
                      lineStyle: {
                        color: '#666'
                      }
                    },
                  }],
                series: [{
                  name: wholeList.legends,
                  type: 'bar',
                  barCategoryGap: '60%',
                  itemStyle: {
                    normal: {
                      color: '#7888ed'
                    },
                    emphasis: {
                      color: '#83bff6'
                    }
                  },
                  data:wholeList.yTotalMoney,
                  smooth: true
                }, {
                  name: '同比',
                  type: 'line',
                  yAxisIndex: 1,
                  itemStyle: {
                    normal: {
                      color: '#FB975B'
                    }
                  },
                  data: wholeList.simple
                }]
              }
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },

      //选择地市
      chooseCityType(city){

      },
      //选择赣品
      chooseDistrictType(district){

      },
      //选择近13个月
      twelveMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 15; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        this.wholeTime = '1'
        if (day > 14) {
          this.currentSalesForm.startTime = dataArr[13]
          this.currentSalesForm.endTime = dataArr[1]
        } else {
          this.currentSalesForm.startTime = dataArr[14]
          this.currentSalesForm.endTime = dataArr[2]
        }
        this.getWholeList()

      },
      //计算最大值
      calMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxval = maxint * 10//让显示的刻度是整数
        return maxval
      },

      //计算最小值
      calMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minint = Math.floor(min / 10)
        let minval = minint * 10//让显示的刻度是整数
        return minval
      },
      //计算最大值
      cityCalMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxval = maxint * 10//让显示的刻度是整数
        return maxval
      },

      //计算最小值
      cityCalMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minint = Math.floor(min / 10)
        let minval = minint * 10//让显示的刻度是整数
        return minval
      },
      //选择近1个月
      // oneMonth (val) {
      //   var dataArr = []
      //   var data = new Date()
      //   var year = data.getFullYear()
      //   data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
      //   for (var i = 0; i < 3; i++) {
      //     data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
      //     var m = data.getMonth() + 1
      //     m = m < 10 ? '0' + m : m
      //     dataArr.push(data.getFullYear() + '-' + (m))
      //   }
      //   if (val == 'city') {
      //     this.wholeTime = '1'
      //     // this.cityForm.startTime = dataArr[1]
      //     this.cityForm.endTime = dataArr[2]
      //     this.getCityList()
      //   } else if (val == 'product') {
      //     this.productTime = '1'
      //     // this.productForm.startTime = dataArr[1]
      //     this.productForm.endTime = dataArr[2]
      //     this.getProductList()
      //   } else if (val == 'transaction') {
      //     this.transactionTime = '1'
      //     // this.transactionForm.startTime = dataArr[1]
      //     this.transactionForm.endTime = dataArr[2]
      //     this.getTransactionList()
      //   } else {
      //     this.wholeTime = '1'
      //     this.cityForm.endTime = dataArr[2]
      //     this.productTime = '1'
      //     // this.productForm.startTime = dataArr[1]
      //     this.productForm.endTime = dataArr[2]
      //     this.transactionTime = '1'
      //     // this.transactionForm.startTime = dataArr[1]
      //     this.transactionForm.endTime = dataArr[2]
      //     this.getCityList()
      //     this.getTransactionList()
      //     this.getProductList()
      //   }
      //   console.dir(this.cityForm)
      // },
    }
  }
</script>

<style>

  /*.JXData-page .el-tabs__nav-wrap {*/
  /*  border: 1px solid rgba(100, 156, 238, 0.4);*/
  /*  !*background-color: #323740;*!*/
  /*}*/

  .JXData-page .el-tabs__item {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    width: 180px;
    height: 45px;
    padding: 0px;
    /*color: #CED4DF;*/
  }

  .JXData-page .el-tabs__active-bar {
    background-color: transparent;
  }

  .JXData-page .el-tabs__header {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0px;
  }

  .JXData-page .el-tabs__item.is-active {
    background-color: #3865A5;
    color: white;
  }

  .JXData-page .el-form-item {
    margin-bottom: 0;
  }

  .JXData-page .el-radio, .JXData-page .el-form-item__label {
    color: #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/area/JXData.vue